export enum SESSION_STORAGE {
  CALLBACK_URL = 'callbackUrl',
}
